module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-hollandsnieuwe-04.a4b0d2e7.jpg";